import template from './loansDetailBasicCharacteristics.html';
import controller from './loansDetailBasicCharacteristics.controller';
import './loansDetailBasicCharacteristics.scss';

let loansDetailBasicCharacteristicsComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    datatable: '<',
    onClick: '&',
    resultTypeInterest: '<',
    coefficient: '<',
    serviceClosed: '<',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansDetailBasicCharacteristicsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailBasicCharacteristics/loansDetailBasicCharacteristics.component.js